import ActionButton from '@/common/components/buttons/ActionButton';
import SerpMonitoringForm from './components/serpMonitoringForm/SerpMonitoringForm';
import { PageWrapper } from '@/common/styles/Wrappers';
import { ContentWrapper } from './SerpMonitoring.styles';
import Loading from '@/common/components/Loading';
import SerpMonitoringTable from './components/serpMonitoringTable/SerpMonitoringTable';
import useSerpMonitoring from './hooks/useSerpMonitoring';

const SerpMonitoring = () => {
	const {
		show,
		setShow,
		selectedConfig,
		setSelectedConfig,
		configs,
		isLoading,
		loadConfigs,
		handleGenerate,
		handleAddConfig,
	} = useSerpMonitoring();

	return (
		<PageWrapper>
			{isLoading && <Loading />}
			<ContentWrapper>
				<ActionButton defaultText='Add config' onClick={handleAddConfig} />
				<ActionButton
					defaultText='Generate report for all configs'
					onClick={() => handleGenerate({})}
					disabled={isLoading}
				/>
			</ContentWrapper>
			{show && (
				<SerpMonitoringForm
					reload={loadConfigs}
					selectedConfig={selectedConfig}
					setShow={setShow}
				/>
			)}
			{!!configs?.length && (
				<SerpMonitoringTable
					setSelectedConfig={setSelectedConfig}
					setShow={setShow}
					configs={configs}
					onGenerate={handleGenerate}
				/>
			)}
		</PageWrapper>
	);
};

export default SerpMonitoring;
